export default __webpack_public_path__ + "static/media/header-image.74acbe41.jpg";